// translations/pages/landing/nl.js

export const landingPageNL = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "Lokale AI-oplossingen waarin gegevensbescherming centraal staat",
    "vision": "De volgende stap in productiviteit: Organisation as a Service. AI-medewerkers nemen werk over van idee tot gecontroleerd resultaat.",
    "intro": "Wij onderzoeken, ontwikkelen en integreren technologieën op het gebied van kunstmatige intelligentie, machine learning en gegevensverwerking. Daaruit ontstaan onze eigen producten en klantspecifieke oplossingen die gegevens lokaal analyseren, structureren, anonimiseren en beschermen — én met [Veridion](veridion) volledig geautomatiseerde AI-medewerkers die samen met mensen volledige werkgebieden binnen het bedrijf overnemen.",
    "detail": "Software die wij bij de klant installeren, draait in diens eigen infrastructuur en heeft geen cloudverbinding nodig. Documenten, gegevens en taalmodellen blijven in eigen huis."
  },
  "partners": {
    "title": "Partners die ons vertrouwen",
    "subtitle": "Bedrijven en onderzoeksinstellingen waar onze AI-organisatie productief wordt ingezet.",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\nEye-tracking- en biosignaaloplossingen voor uw onderzoek",
        "description": [
          "BiSigma is gespecialiseerd in systemen voor het meten en analyseren van biosignalen en in uiterst nauwkeurige eye-trackingoplossingen voor wetenschap, klinische praktijk en industrieel onderzoek.",
          "pAIoneer Labs GmbH heeft bij BiSigma de softwareontwikkeling volledig vervangen door AI, die met succes software voor het meten en analyseren van biosignalen ontwikkelt en continu doorontwikkelt."
        ],
        "cta": "BiSigma bezoeken"
      }
    }
  },
  "products": {
    "title": "Producten",
    "subtitle": "Wij verkopen software als desktopapplicatie voor de werkplek, als serversoftware on-premises of in de cloud van de klant en als abonnement op ons platform, zoals de [tradingassistent](finance), die onze AI-medewerkers zelf ontwikkelen. Daarnaast bouwen wij AI-systemen volgens de eisen van de klant en bieden wij advies en trainingen.",
    "partnerLabel": "Partnerproduct",
    "priceOnRequest": "Prijs op aanvraag",
    "request": "Aanvraag sturen",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveil herkent en anonimiseert persoonsgegevens in Word-, Excel-, OpenDocument-, PDF- en tekstbestanden voordat ze in AI-tools, tests en analyses terechtkomen of naar derden gaan. De herkenning combineert {presidio}, {spacy} en {flair} en werkt in het Duits, Engels, Frans, Italiaans en Spaans.",
          "De desktopversie draait zelfstandig op gangbare computers met Windows, macOS of Linux, zonder GPU en zonder afhankelijkheid van het netwerk; de bestanden verlaten de werkplek niet. De API-versie draait in de infrastructuur van de klant, on-premises of in de eigen cloud, en integreert de anonimisering in bestaande systemen en workflows.",
          "De replace-modus vervangt persoonsgegevens door placeholders voor de compliancedocumentatie, de fake-modus door plausibele vervangende waarden voor testomgevingen; de documentstructuur blijft behouden. Met AnonChat gaat een geanonimiseerd document pas na een voorbeeldweergave naar ChatGPT, Claude, Gemini of een intern taalmodel."
        ],
        "cta": "Kyveil bekijken"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "Eén schepper, oneindig veel oplossingen.",
        "text": [
          "De bedrijfs-AI van pAIoneer Labs GmbH: ze stuurt de hele onderneming aan, als volledige organisatie van AI-medewerkers met business units van softwareontwikkeling via elektronica en quantum computing tot sales en administratie, geleid door een eigen coördinatielaag.",
          "Dit personeelsbestand brengt projecten, boekhouding, bedrijfskennis, onderzoek, ontwikkeling en data-analyse zelfstandig tot het einde. Zijn communicatie is speltheoretisch geoptimaliseerd, en heeft het een vermogen nodig dat nog niet bestaat, dan bouwt het daarvoor een eigen AI-systeem.",
          "Het draait on-premises, in de eigen cloud of op ons platform. De [tradingassistent](finance) daar ontwikkelt het zelf, en in de chat is het zijn AI."
        ],
        "points": [
          "Integreert zich in elk proces",
          "Leert zelfstandig bij",
          "Creëert ontbrekende vermogens zelf",
          "Planbaar in vaste cycli"
        ],
        "cta": "Veridion bekijken"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddy is een AI-gebaseerd, modulair agentsysteem voor bedrijven dat administratieve kantoortaken automatiseert.",
          "Vijf rollen dekken de werkdag af: de assistent coördineert afspraken, stelt e-mails op en handelt dagelijkse taken af. De coach begeleidt de emotionele en sociale kant van het werk, helpt bij conflicten en ondersteunt de persoonlijke ontwikkeling. De privacyhulp beantwoordt vakvragen over gegevensbescherming en privacy en kan worden getraind op andere vakgebieden zoals brandveiligheid of compliance. De trainingscoach stelt opleidingsplannen, onboardingtrajecten en trainingsmodules op, en de adviseur analyseert geüploade documenten, ondersteunt beslissingen en geeft strategische aanbevelingen.",
          "RoBuddy wordt voor 100 % volgens Duitse normen (AVG, BSI-Grundschutz) gehost en beheerd en kan naadloos worden gekoppeld aan Nextcloud of aan elke netwerkschijf.",
          "RoBuddy is het agentische systeem voor kantoorwerk en kan met Veridion worden verbonden tot één bedrijfs-AI die de hele onderneming omvat: RoBuddy neemt de taken op de werkplek over, Veridion sluit de systemen en gegevens van de onderneming aan."
        ],
        "cta": "RoBuddy bekijken",
        "vendorNote": "RoBuddy is een product van Dr. Hornecker Software-Entwicklung und IT-Dienstleistungen. De distributie verloopt via pAIoneer Labs GmbH."
      }
    }
  },
  "platformNote": {
    "title": "SaaS-platform",
    "description": "Deze applicatie gebruikt u als abonnement direct in de browser, zonder installatie. Ze draait op ons eigen platform, voor het inloggen is een tweede factor vereist, en alle AI-aanroepen lopen via één centraal toegangspunt met vaste quota.",
    "apps": {
      "finance": {
        "name": "AI-tradingassistent",
        "text": "U koppelt uw effectenrekening, stelt vragen over uw posities in gewone taal en ziet welke berichten de koersen hebben beïnvloed. De prognose komt voor elk financieel instrument uit een eigen machine-learningmodel dat dagelijks opnieuw wordt getraind, en een handelsautomaat kan de signalen verhandelen. De assistent wordt ontwikkeld door onze AI-medewerkers; in de chat zijn zij ook zijn AI.",
        "cta": "Tradingassistent bekijken"
      }
    }
  },
  "services": {
    "title": "Kerndiensten",
    "veridion": {
      "title": "AI-medewerkers",
      "description": "Hele werkvelden, ingevuld met AI-medewerkers die zich in de processen en gereedschappen van de onderneming integreren en werk zelfstandig tot het einde brengen. Zo werken wij zelf: pAIoneer Labs GmbH loopt erover.",
      "cta": "Veridion bekijken",
      "features": [
        "Organisation as a Service",
        "Business units van AI-medewerkers",
        "Speltheoretisch geoptimaliseerde communicatie",
        "On-premises of eigen cloud"
      ]
    },
    "custom": {
      "title": "Klantspecifieke AI-systemen",
      "description": "Wij ontwikkelen systemen voor het analyseren, verwerken, structureren, anonimiseren en beschermen van gegevens volgens de eisen van de klant en integreren ze in lokale IT-infrastructuren of in die van de klant zelf.",
      "features": [
        "Gebruik zonder cloud",
        "Productontwikkeling",
        "Prototypen",
        "Onderzoeks- en ontwikkelingsprojecten"
      ]
    },
    "dataanalysis": {
      "title": "Data-analyse in gesprek",
      "description": "Een AI-medewerker beantwoordt vragen aan aangesloten gegevensbronnen. Hij leest de catalogi, schema’s en kolommen van de databases, legt vóór de toegang tot de gegevens een analyseplan voor en heldert dubbelzinnigheden op.",
      "features": [
        "SQL-gegevensbronnen",
        "Correlatie en regressie",
        "Tabellen en diagrammen",
        "Export naar PDF en PowerPoint"
      ]
    },
    "memory": {
      "title": "Bedrijfsgeheugen",
      "description": "Een geheugen in plaats van zoeken in documenten: feiten, beslissingen, taken en procedures, verbonden met de projecten, personen, systemen en documenten waarbij ze horen, met de tijd waarin ze gelden. Het groeit vanzelf uit gesprekken, meetings en werkresultaten; een nieuwere beslissing vervangt de oudere over hetzelfde onderwerp, niets gaat verloren.",
      "features": [
        "Kennisgraaf",
        "Feiten met hun tijd",
        "Beslissingen, nooit verloren",
        "Toegang volgens verantwoordelijkheid"
      ]
    },
    "elektronik": {
      "title": "Elektronica & firmware",
      "description": "Ontwikkeling dicht op de hardware als dienst: schakelingsontwerp en simulatie als digitale tweeling, firmware tot aan de sensor, beoordeling van componenten en alternatieven voordat er iets wordt gebouwd.",
      "features": [
        "Digitale tweelingen",
        "Embedded firmware",
        "Datasheet-analyse",
        "Componentbeoordeling"
      ]
    },
    "quantum": {
          "title": "Soevereine LLM's & Quantum-AI",
          "description": "Ons doel onder Veridion: compacte taalmodellen Made in Germany ontwikkelen die straks concurreren met grote modellen uit de VS en China, plus eigen Quantum Transformers.",
          "cta": "Quantum bekijken",
          "features": [
                "LLM's Made in Germany",
                "Quantum Transformers",
                "Eigen Quantum IDE",
                "AI ontwikkelt AI"
          ]
    },
    "kyveil": {
      "title": "Lokale anonimisering zonder GPU",
      "description": "Kyveil anonimiseert persoonsgegevens lokaal, als desktopapplicatie op gangbare computers met Windows, macOS of Linux of als REST-API in de infrastructuur van de klant, zonder verplichte cloud en zonder GPU.",
      "cta": "Kyveil bekijken",
      "features": [
        "Anonimisering vóór AI",
        "PII-herkenning met NLP",
        "Windows, macOS, Linux",
        "REST-API on-premises"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "AI-ondersteunde softwareontwikkeling heeft betrouwbare context nodig. IDD legt doelen, niet-doelen, scenario’s, agentregels en beslissingen vast als bruikbaar projectgeheugen.",
      "cta": "IDD bekijken",
      "features": [
        "Agentische ontwikkeling",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "Scenario’s als tests"
      ]
    },
    "finance": {
      "title": "Financiën & marktanalyse",
      "description": "Achter de tradingassistent staat een eigen business unit van digitale medewerkers: AI-datascientists en finance-experts. Ze beoordelen nieuws in realtime, analyseren de emoties van financieel nieuws en rekenen in de chat zelf op de marktgegevens: correlaties, regressies, diagrammen en de balans van de eigen prognoses, elk getal uit een uitgevoerde rekenstap. Daaronder werken een machine-learningprognose per financieel instrument en automatische handel op de oefenrekening en met echt geld.",
      "cta": "Financiële AI bekijken",
      "features": [
        "AI-datascientists & finance-experts",
        "Nieuws in realtime, met emotieanalyse",
        "ML-prognose per financieel instrument",
        "Automatische handel"
      ]
    },
    "consulting": {
      "title": "Advies",
      "description": "Wij adviseren technisch, organisatorisch en strategisch over de invoering en de beveiliging van AI en over het gebruik ervan in overeenstemming met de regels.",
      "features": [
        "AI-governance",
        "Gegevensbeheer",
        "Gegevensbescherming",
        "Informatiebeveiliging"
      ]
    }
  },
  "contact": {
    "title": "Contact",
    "addressLabel": "Adres",
    "phoneLabel": "Telefoon",
    "emailLabel": "E-mail",
    "cta": "Bericht schrijven"
  }
};
